import type { OnInit, OnDestroy } from '@angular/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Inject,
  Input,
  NgZone,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';

declare const window;

@Component({
    selector: 'nmo-content-slider-item',
    templateUrl: './content-slider-item.component.html',
    styleUrls: ['./content-slider-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('translateSlide', [
            state('center, void', style({ transform: 'none' })),
            state('left', style({ transform: 'translate3D(-100%, 0, 0)' })),
            state('right', style({ transform: 'translate3D(100%, 0, 0)' })),
            transition('* => left, * => right, left => center, right => center', animate('300ms cubic-bezier(0.35, 0, 0.25, 1)')),
        ]),
    ],
    standalone: false
})
export class ContentSliderItemComponent implements OnInit, OnDestroy {
  _position;
  _positionIndex;
  private hammer;

  @ViewChild('slideInteraction', { static: true }) slideInteraction: ElementRef;

  @Input()
  set position(positionValue: number) {
    this._positionIndex = positionValue;
    this.computePosition();
    this.changeDetectorRef.markForCheck();
  }

  @HostBinding('class') class = 'slider-content-item';

  @HostBinding('class.slider-content-item-active')
  get activeClass(): boolean {
    return this._positionIndex === 0;
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private _zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.computePosition();
      this._zone.runOutsideAngular(() => {
        if (typeof window !== 'undefined' && window.Hammer) {
          this.hammer = new window.Hammer(this.slideInteraction.nativeElement);
          this.hammer.on('pan', (event) => {
            if (event.additionalEvent === 'panleft' || event.additionalEvent === 'panright') {
              if (!event.isFinal) {
                const percentage = (20 * event.deltaX) / window.innerWidth; // NEW: our % calc
                this.slideInteraction.nativeElement.style.transform =
                  'translate3d(0, 0, 0) translateX( ' + percentage + '% )';
              }
            }
          });
        }
      });
    }
  }
  ngOnDestroy(): void {
    if (this.hammer) {
      this.hammer.off('pan');
    }
  }

  computePosition(): void {
    if (this._positionIndex < 0) {
      this._position = 'left';
    } else if (this._positionIndex > 0) {
      this._position = 'right';
    } else {
      this._position = 'center';
    }
  }
}
